module.exports = __webpack_public_path__ + "static/tree_back-20a03a0e6a07e8fdc5178fdeb7de8c37.png";